export default __webpack_public_path__ + "images/b1e504a8f68c9303c22e6b068ffe1375.svg";